module.exports = __webpack_public_path__ + "img/monitor-bg.71dc1c4a.png";